// Stepts for homepage
const careerSteps = [
{
    element: ".table",
    popover: {
        className: 'first-step-popover-class',
        title: '🙋<br>Začínáme',
        description: '<b>Tady najdeš aktuálně otevřené pracovní pozice.</b> Pár jsme jich pro ukázku přidali a o pár řádků níže můžeš vidět jejich výpis.',
        position: 'bottom',
        showButtons: true,
    },

},
{
    element: "#sidebar",
    popover: {
        title: '📎<br>Šablony pracovních pozic a inzerátů',
        description: '<b>V nastavení můžeš vytvářet a ukládat šablony.</b> Při zadávání nové pozice si pak stačí vybrat šablonu a všechny údaje se ti sami předvyplní.',
        position: 'right-center',
        showButtons: true,
    },

},
{
    element: ".guide-step-careers-3",
    popover: {
        className: 'image-popover',
        title: '<a href="../careersite" target="_blank" title="Více"><img src="/images/guide-careers-1.png"></a>',
        description: 'Tady se můžeš později prokliknout a editovat celou vaši firemní kariérní stránku.',
        position: 'bottom',
        showButtons: true,
    },

},
{
    element: ".guide-step-careers-4",
    popover: {
        title: ' ',
        description: 'Přidat novou pracovní pozici (a případně inzerát) můžeš tady.',
        position: 'bottom-right',
        showButtons: true,
    },

},
{
    element: ".table",
    popover: {
        title: ' ',
        description: 'Tady vidíš <b>přehled pracovních pozic</b>. V případě, že je aktivní modul "Hiring" zde zadává text inzerátu.',
        position: 'bottom',
        showButtons: true,
    },

},
{
    element: ".action-td",
    popover: {
        title: ' ',
        description: 'V případě, že je aktivní modul "Hiring", můžeš kliknutím zde <b>sdílet</b> inzerát na Facebook, Twitter nebo LinkedIn <b>na jeden klik</b>. <br><br>Kliknutím na ikonu <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-edit-3"><path d="M12 20h9"></path><path d="M16.5 3.5a2.121 2.121 0 0 1 3 3L7 19l-4 1 1-4L16.5 3.5z"></path></svg> můžeš pracovní pozici upravit.',
        position: 'bottom',
        showButtons: true,
    },

},
{
    element: "#sidebar",
    popover: {
        className: 'first-step-popover-class',
        title: 'Prohlédni si aktuální zaměstnance',
        description: 'Objev jak vypadá Onboarding s funkcí timeline <br>(3 min)<br>',
        position: 'right-center',
        showButtons: true,
        showButtons: true,         // Do not show control buttons in footer
        doneBtnText: 'Ano, pokračovat dál',
        nextBtnText: 'Rozumím',        // Next button text for this step
        prevBtnText: 'Zpět',
    },
    onNext: () => {
        // Prevent moving to the next step
        window.location.assign("/onboarding#guide");

    }
},
]



export default careerSteps
